import { Channel, SimpleReactionsList } from 'stream-chat-react';
import { init, SearchIndex } from 'emoji-mart';
import data from '@emoji-mart/data';
import ChannelInner from './ChannelInner';
import { EmptyChannel } from './EmptyChannel';

const LoadingIndicator = () => null;

init({ data });

export const ChannelContainer = () => {
	return (
		<Channel
			EmptyStateIndicator={EmptyChannel}
			LoadingIndicator={LoadingIndicator}
			ReactionsList={SimpleReactionsList}
			emojiSearchIndex={SearchIndex}
		>
			<ChannelInner />
		</Channel>
	);
};
